import { InjectionToken } from "@angular/core";
import { IAddPaymentMethodModalService } from "./i-add-payment-method-modal.service";

export const addPaymentMethodModalServiceInjectionToken: InjectionToken<IAddPaymentMethodModalService> =
	new InjectionToken<IAddPaymentMethodModalService>("digital-signage.user-dashboard.dashboard-web.AddPaymentMethodModalService");
